import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFilterLines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 12h12M3 6h18M9 18h6"
    />
  </svg>
);
SvgFilterLines.displayName = 'FilterLines';
export default SvgFilterLines;
